module.exports = __webpack_public_path__ + "img/oil-temperature.a4b83d10.svg";